/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { isBefore, parseISO } from 'date-fns';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import NextLink from 'components/NextLink';
import ShowOnlyClient from 'components/ShowOnlyClient';

import { formatDuration } from 'utils/helpers/dates';

import styles from './styles.module.scss';

const PlayButton = ({ link, onClick, text, ...data }) => {
	const publishDate = data.publishDate && parseISO(data.publishDate);
	const toDate = parseISO(data.toDate);
	const [timerHandle, setTimerHandle] = useState(null);
	const [timerOn, setTimerOn] = useState(
		publishDate && isBefore(new Date(), publishDate)
	);

	const checkTimer = useCallback(() => {
		setTimerOn(isBefore(new Date(), publishDate));
	}, []);

	const stopTimer = useCallback(() => {
		if (timerHandle) {
			clearInterval(timerHandle);
			setTimerHandle(null);
		}
	}, [timerHandle]);

	useEffect(() => {
		if (timerOn) {
			setTimerHandle(setInterval(checkTimer, 1000));
		}

		return () => {
			stopTimer();
		};
	}, []);

	useEffect(() => {
		if (!timerOn) {
			stopTimer();
		}
	}, [timerOn]);

	const renderTimer = useCallback(() => {
		const timeLabel = formatDuration(publishDate, new Date(), {
			withZeros: true
		});

		return (
			<div className={styles.counter}>
				<div className={styles.label}>Трансляция начнется через:</div>
				<div className={styles.time}>{timeLabel}</div>
			</div>
		);
	}, [data.publishDate]);

	const renderInfo = useCallback(
		() =>
			timerOn ? (
				renderTimer()
			) : (
				<div className={styles.counter}>
					<div className={styles.label}>Прямая трансляция</div>
					<div className={styles.value}>Начать просмотр</div>
				</div>
			),
		[timerOn, renderTimer]
	);

	const ButtonInner = useMemo(
		() => (
			<>
				<div className={styles.icon} />
				{isBefore(new Date(), toDate) ? (
					<ShowOnlyClient>{renderInfo()}</ShowOnlyClient>
				) : (
					<div className={styles.counter}>
						<div className={styles.value}>Начать просмотр</div>
						{text && <div className={styles.text}>{text}</div>}
					</div>
				)}
			</>
		),
		[data.toDate, renderInfo, text]
	);

	return link ? (
		<NextLink className={styles.button} href={link}>
			{ButtonInner}
		</NextLink>
	) : (
		<div className={styles.button} onClick={onClick}>
			{ButtonInner}
		</div>
	);
};
PlayButton.propTypes = {
	publishDate: PropTypes.string,
	toDate: PropTypes.string,
	link: PropTypes.string,
	text: PropTypes.string,
	onClick: PropTypes.func
};

export default PlayButton;
